<template>
	<edit-layout @save="saveTeamData" @cancel="$emit('browsMode')">
		<el-form label-position="left" label-width="100px" :model="ruleForm" :rules="rules" ref="teamFormUnder18">
			<el-form-item label="故事帳號">
				{{editStoryData.account}}
			</el-form-item>
			<el-form-item label="組別密碼" prop="password">
				<el-col :span="10">
					<el-input v-model="ruleForm.password" placeholder="密碼請至少設定 6 個字元"></el-input>
				</el-col>
			</el-form-item>
			<el-form-item label="小組名稱" prop="teamName">
				<el-input v-model="ruleForm.teamName" placeholder="此小組名稱為方便輔導員管理故事資料，非故事名稱"></el-input>
			</el-form-item>
			<el-form-item :label="(i==0)?'小組成員':''" :prop="'members.' + i" v-for="(member, i) in ruleForm.members" :key="i" :rules="{required: true, validator: validateMember, trigger: 'blur'}">
				<el-row class="member" type="flex" :gutter="5">
					<el-col :span="10">
						<el-input placeholder="輸入姓名" v-model="member.name"></el-input>
					</el-col>
					<el-col :span="8">
						<el-input placeholder="輸入年級" v-model="member.grade"></el-input>
					</el-col>
					<el-col :span="2">
						<span>年級</span>
					</el-col>
					<el-col :span="8">
						<el-input placeholder="輸入年齡" v-model="member.age"></el-input>
					</el-col>
					<el-col :span="2">
						<span>歲</span>
					</el-col>
					<el-col :span="2">
						<el-button v-if="ruleForm.members.length > 1" icon="el-icon-minus" type="info" circle size="mini" @click="removeMember(i)"></el-button>
					</el-col>
				</el-row>
			</el-form-item>
			<el-form-item>
				<div class="row" align-y="center" gutter="20">
					<el-button icon="el-icon-plus" type="primary" circle size="mini" @click="addMember"></el-button>
					<span class="color-text3">* 不限挑戰人數，但建議人數為五人。</span>
				</div>
			</el-form-item>
			<div class="instructor">
				<el-form-item :label="'第' + (i+1)+ '位輔導員'" v-for="(instructor,i) in ruleForm.instructors" :key="i">
					<el-row type="flex" :gutter="10">
						<el-col>
							<div>{{instructor.name}}&emsp;{{instructor.phone}}</div>
						</el-col>
						<el-col v-if="i > 0">
							<el-button icon="el-icon-minus" type="info" circle size="mini" @click="removeInstructor(i)"></el-button>
						</el-col>
					</el-row>
				</el-form-item>
				<el-form-item label="新增輔導員">
					<div class="row" align-x="left">
						<div class="button-tp bind-account-btn color-white bg-blue1" @click="dialogVisible = true">已有帳號，點選帶入資料</div>
					</div>
				</el-form-item>
			</div>
		</el-form>
		<el-dialog class="instructor-dialog" :visible.sync="dialogVisible" :before-close="handleDialogClose">
			<div class="title">
				<span class="center">輸入帳號(email)，連結另一位夥伴</span>
			</div>
			<div class="input-box">
				<el-input placeholder="輸入Email" v-model="newInstructorEmail" @keyup.enter.native="searchInstructor"></el-input>
			</div>
			<div>
				<el-row type="flex" justify="center">
					<el-button type="info" @click="handleDialogClose">取消</el-button>
					<el-button type="danger" class="bg-pink1 color-white" @click="searchInstructor">確定</el-button>
				</el-row>
			</div>
		</el-dialog>
	</edit-layout>
</template>

<script>
import uuid from "uuid";
import EditLayout from "./EditLayout.vue";
import validator from "@/libs/validator";
import { mapActions, mapMutations } from "vuex";

export default {
	components: { EditLayout },
	props: ["editStoryData"],
	data() {
		return {
			dialogVisible: false,
			teamData: {},
			ruleForm: {
				teamName: "",
				members: [
					{
						index: uuid.v4(),
						name: "",
						grade: "",
						age: ""
					}
				],
				instructors: [
					{
						id: "",
						name: ""
					}
				]
			},
			rules: {
				teamName: [
					{ required: true, message: "請輸入小組名稱", trigger: "blur" }
				],
				password: [
					{
						required: true,
						message: "請輸入密碼（至少6字元）",
						trigger: "blur"
					},
					{ min: 6, message: "長度至少為6字元", trigger: "blur" }
				]
			},
			newInstructorEmail: ""
		};
	},
	methods: {
		...mapMutations("story", ["updateEditStoryData"]),
		...mapActions("story", ["searchAccount", "updateStory"]),
		handleDialogClose() {
			this.newInstructorEmail = "";
			this.dialogVisible = false;
		},
		validateMember(rule, value, callback) {
			if (value.name === "") {
				callback(new Error("請輸入姓名"));
			} else if (value.grade === "") {
				callback(new Error("請輸入年級"));
			} else if (value.age === "") {
				callback(new Error("請輸入年紀"));
			}
			callback();
		},
		async searchInstructor() {
			if (validator.isEmail(this.newInstructorEmail)) {
				let data = {
					account: this.newInstructorEmail
				};
				try {
					let res = await this.searchAccount(data);
					let instructor = {
						index: uuid.v4(),
						...res.data,
					};
					this.ruleForm.instructors.push(instructor);
					this.newInstructorEmail = "";
					this.dialogVisible = false;
				} catch (e) {
					this.$message.error(e);
				}
			} else {
				this.$message.error("請輸入完整輔導員帳號email!");
			}
		},
		addMember() {
			let data = {
				index: uuid.v4(),
				name: "",
				grade: "",
				age: ""
			};
			this.ruleForm.members.push(data);
		},
		removeMember(i) {
			_.pullAt(this.ruleForm.members, i);
			this.ruleForm.members = _.cloneDeep(this.ruleForm.members);
		},
		removeInstructor(i) {
			_.pullAt(this.ruleForm.instructors, i);
			this.ruleForm.instructors = _.cloneDeep(this.ruleForm.instructors);
		},
		validatedAll() {
			var result = false;
			this.$refs["teamFormUnder18"].validate(valid => {
				if (valid) {
					result = true;
				} else {
					result = false;
				}
			});
			return result;
		},
		deleteObjIndex(obj) {
			for (let item of obj) {
				item.index = undefined;
			}
		},
		saveTeamData() {
			this.$refs["teamFormUnder18"].validate(async valid => {
				if (valid) {
					let data = {
						id: this.editStoryData.id,
						password: this.ruleForm.password,
						team_name: this.ruleForm.teamName,
						team_members: _.cloneDeep(this.ruleForm.members),
						counselors: _.cloneDeep(this.ruleForm.instructors)
					};
					this.deleteObjIndex(data.team_members);
					this.deleteObjIndex(data.counselors);
					await this.updateStory(data);
					this.updateEditStoryData(data);
					this.$emit("browsMode");
					this.$message.success("儲存成功");
				} else {
					this.$message.error("小組資料需要完整才能夠儲存喔！");
				}
			});
		},
		init() {
			this.ruleForm.instructors = this.editStoryData.counselors;
			this.ruleForm.teamName = this.editStoryData.team_name;
			this.ruleForm.members = this.editStoryData.team_members;
			this.ruleForm.password = this.editStoryData.password;
		}
	},
	created() {
		this.init();
	}
};
</script>

<style lang="scss" scoped>
.bind-account-btn {
	padding: 0 10px;
	height: 25px;
}

.instructor-dialog {
	.title {
		font-size: 14px;
		font-weight: 500;
		margin-bottom: 22px;
	}

	.input-box {
		margin-bottom: 23px;
	}
}
</style>

